const korean = {
  applicationName: '도미체인 지갑',
  unlockWallet: '지갑 잠금 해제',
  choosePassword: '비밀번호를 선택하세요.',
  pickPassword: '지갑을 보호할 비밀번호를 설정하세요 (12자 이상).',
  passwordTooShort: '12자 이상 사용하세요.',
  passwordMismatch: '비밀번호가 일치하지 않습니다.',
  skipPassword: '건너뛰기(비밀번호 없음)',
  skipForNow: '나중에 하기',
  plaintextWarning:
    '비밀번호가 없으면 복구 문구가 이 기기에 암호화되지 않은 상태로 저장됩니다.',
  noPasswordSet: '이 지갑에는 비밀번호가 없습니다.',
  secureWalletTitle: '지갑 보호',
  secureWalletDescription:
    '이 지갑은 비밀번호 없이 저장되어 있습니다. 지금 비밀번호를 설정하여 이 기기에서 복구 문구를 암호화하세요.',
  secureWalletAction: '지갑 암호화',
  upgradePasswordTitle: '비밀번호 업데이트',
  upgradePasswordDescription:
    '현재 지갑 비밀번호가 최소 요구 사항인 12자보다 짧습니다. 복구 문구를 계속 보호하려면 새 비밀번호를 설정하세요.',
  updatePasswordAction: '비밀번호 업데이트',
  securingWallet: '지갑 보호 중...',
  walletSecured: '지갑이 보호되었습니다',
  reenterPassword: '계속하려면 비밀번호를 다시 입력하세요.',
  incorrectPassword: '비밀번호가 올바르지 않습니다.',
  enableAutoApproveTitle: '자동 승인 사용',
  enableAutoApproveWarning:
    '이 사이트가 매번 확인 없이 거래를 보낼 수 있게 됩니다. 확인하려면 비밀번호를 입력하세요.',
  ifForgetPassword:
    '비밀번호를 잊은 경우 시드 단어를 사용하여 지갑을 복원해야 합니다.',
  restoreExistingWallet: '기존 지갑 복원',
  createNewWallet: '새 지갑 만들기',
  createToHold: 'Domichain 및 DPL 토큰을 보관할 새 지갑 만들기',
  seedSafePlace: '다음 열두 단어를 적어 안전한 곳에 보관하세요:',
  privateKeysStored:
    '개인 키는 현재 컴퓨터나 장치에만 저장됩니다. 브라우저의 저장 공간이 비워지거나 장치가 손상되거나 분실된 경우 지갑을 복원하려면 이 단어가 필요합니다.',
  iHaveSaved: '나는 이 말을 안전한 곳에 저장해 두었습니다.',
  downloadMnemonic: '백업 니모닉 파일 다운로드(필수)',
  pleaseReenter: '시드 구문을 다시 입력하여 저장했는지 확인하십시오.',
  pleaseType: '확인을 위해 시드 문구를 입력하세요.',
  newPassword: '새 비밀번호',
  newPasswordOptional: '새 비밀번호(선택 사항)',
  confirmPassword: '비밀번호 확인',
  back: '뒤쪽에',
  createWallet: '지갑 생성',
  unlockingWallet: '지갑을 여는 중...',
  password: '비밀번호',
  keepWalletUnlocked: '지갑을 잠금 해제 상태로 유지',
  restoreExisting: '기존 지갑 복원',
  restoreUsing:
    '12개 또는 24개의 시드 단어를 사용하여 지갑을 복원하십시오. 이렇게 하면 이 장치에 있는 기존 지갑이 삭제됩니다.',
  noHardwareWallet:
    '여기에 하드웨어 지갑 시드 문구를 입력하지 마십시오. 하드웨어 지갑은 웹 지갑 생성 후 선택적으로 연결할 수 있습니다.',
  mnemonicFailed:
    '니모닉 유효성 검사에 실패했습니다. 유효한 BIP 39 시드 문구를 입력하십시오.',
  seedWords: '시드 단어',
  cancel: '취소',
  next: '다음',
  addAccount: '계정을 추가',
  name: '이름',
  importPrivateKey: '개인 키 가져오기',
  pastePrivateKey: '개인 키 가져오기',
  add: '추가하다',
  close: '닫다',
  addCustomNetwork: '사용자 지정 네트워크 추가',
  url: 'URL',
  done: '완료',
  continue: '계속하다',
  export: '내보내다',
  delete: '삭제',
  send: '보내다',
  receive: '받다',
  wrap: '랩핑',
  unwrap: '언랩핑',
  wrapDomiTitle: 'DOMI 랩핑',
  unwrapDomiTitle: 'wDOMI 언랩핑',
  wrapDomiInfo:
    '랩핑은 네이티브 DOMI를 wDOMI 토큰으로 변환합니다. wDOMI는 FuFuture처럼 DPL 토큰을 사용하는 앱에 예치할 수 있으며, 언제든지 다시 네이티브 DOMI로 언랩핑할 수 있습니다.',
  wrapUsdtTitle: 'USDT 랩핑',
  wrapUsdtInfo:
    '랩핑은 레거시 USDT를 1:1로 wUSDT 토큰으로 전환합니다. 브리지가 제출된 USDT를 소각하고 동일한 수량의 wUSDT를 지갑으로 발행합니다.',
  unwrapDomiInfo: '언랩핑은 wDOMI를 메인 계정의 네이티브 DOMI로 되돌립니다.',
  unwrapDomiCloseNote:
    '전체 잔액을 언랩핑하면 wDOMI 계정이 닫히고 렌트 보증금도 함께 반환됩니다.',
  wrapDomiConsolidateNote:
    '기존 wDOMI도 기본(연결) 토큰 계정으로 이동되며, 이전 계정은 닫히고 렌트 보증금이 반환됩니다.',
  unlock: '터놓다',
  confirmAddress: '지갑 주소 확인',
  checkLedger:
    "원장을 확인하고 표시된 주소가 선택한 주소인지 확인합니다. 그런 다음 '완료'를 클릭합니다.",
  addHardwareWallet: '하드웨어 지갑 추가',
  connectLedger:
    "원장을 연결하고 Domichain 애플리케이션을 엽니다. 준비가 되면 '계속'을 클릭합니다.",
  loadingFromHardwareWallet: '하드웨어 지갑에서 계정 로드',
  copied: '복사됨',
  copyToClipboard: '클립 보드에 복사',
  editAccountName: '계정 이름 편집',
  auxiliaruAccount: '이것은 보조 토큰 계정입니다.',
  viewOnDomiexplorer: 'Domiexplorer에서 보기',
  viewDetails: '세부 정보보기',
  tokenName: '토큰 이름',
  tokenSymbol: '토큰 심볼',
  mainAccount: '메인 계정',
  account: '계정',
  refresh: '새로 고치다',
  wontRecover:
    '시드 문구와 계정 개인 키가 없으면 현재 계정을 복구할 수 없습니다. 이 작업은 브라우저에서 모든 현재 계정을 삭제합니다.',
  perventLoss:
    "자금 손실을 방지하려면 모든 현재 계정에 대한 시드 문구와 개인 키가 있는지 확인하십시오. 사용자 메뉴에서 '니모닉 내보내기'를 선택하면 볼 수 있습니다.",
  enterSeedPhase: '확인을 위해 시드 문구를 입력하세요.',
  deleteAndLogout: '니모닉 삭제 및 로그아웃',
  editAccount: '계정 수정',
  addressReceive: '이 주소를 사용하여 수신할 수 있습니다.',
  depositAddress: '입금 주소',
  enterDomichainAddress: '도미체인 주소 입력',
  enterDPLAddress: 'DPL 토큰 또는 도미체인 주소 입력',
  amount: '양',
  max: '최대',
  recipientAddress: '받는 사람 주소',
  use1: '이용해주세요',
  use2: '웜홀 차원문 다리',
  use3: '자산을 연결합니다.',
  save: '구하다',
  exportAccount: '계정 내보내기',
  privateKey: '개인 키',
  reveal: '드러내다',
  mnemonic: '니모닉',
  connect: '연결하다',
  exportMnemonic: '니모닉 내보내기',
  importHardwareWallet: '하드웨어 지갑 가져오기',
  selectAccount: '계정 선택',
  editCustomEndpoint: '사용자 지정 끝점 편집',
  addCustomEndpoint: '사용자 지정 끝점 추가',
  hardwareWallet: '하드웨어 지갑',
  selectNetwork: '네트워크 선택',
  selectLanguage: '언어 선택',
  connections: '사이',
  manageConnections: '연결 관리',
  wallet: '지갑',
  walletBalance: '월렛 잔액',
  expandView: '전개도',
  appName: 'DWallet',
  disconnect: '연결 끊기',
  connectedDapps: '연결된 Dapp',
  yourReferralLink: 'Your referral link',
  sendRequest: '요청 보내기',
  waitingForConfirmation: '확인을 기다리는 중',
  withdrawFunds: '자금 인출',
  deposit: '보증금',
  metamaskConnected: '메타마스크 연결됨',
  transactionPending: '거래 대기 중',
  language: '언어',
  confirmMnenonic: '니모닉 확인',
  creatingWallet: '지갑 생성 중...',
  walletCreated: '지갑 생성됨',
  time: '시간',
  txHash: '트랜잭션 해시',
  type: '유형',
  transfer: '전송',
  other: '기타',
  approve: '승인',
  deny: '거부',
  connectWalletDialogQuestion:
    '이 Dapp이 도메체인 계정에 액세스하도록 허용하시겠습니까?',
  connectWalletDialogNotice:
    '신뢰할 수 있는 사이트와만 연결하세요. 모든 거래를 직접 승인하며, "연결된 앱" 섹션에서 사이트별로 자동 승인을 켤 수 있습니다.',
  network: '네트워크',
  wantsToConnect: '지갑에 연결하려고 합니다',
  allowTransactionDialogQuestion:
    '이 디앱이 트랜잭션을 전송하도록 허용하시겠습니까?',
  airdrop: '에어드롭',
  addressHasNoFunds: '이 주소에는 자금이 없습니다. 정확한 주소인가요?',
  mintNewToken: '민트 새 토큰',
  mintNewTokenDescription:
    '새로운 가치 없는 토큰을 생성하고 받습니다. 이 작업을 수행하려면 DOMI가 거래 수수료를 부담해야 합니다.',
  tokenDecimals: '토큰 소수점',
  stake: '스테이크',
  yourStake: '내 스테이크',
  stakeAccount: '스테이크 계정',
  status: '상태',
  balance: '잔액',
  activeStake: '활성 스테이크',
  inactiveStake: '비활성 스테이크',
  reward: '보상',
  unstake: '언스테이크하기',
  claim: '주장하다',
  availableForWithdraw: '인출 가능',
  totalRewardWithdrawn: '인출된 총 보상',
  totalBalanceExpected: '예상 총 잔액',
  withdrawStake: '스테이크 인출하기',
  startStaking: '스테이킹 시작',
  stakingChoosePlanDescription:
    "'아래의 계획 중 하나를 선택하여 DOMI를 스테이킹하고 보상을 받으세요.",
  stakingDepositDescription:
    '지정된 토큰 금액으로 BNB Smart Chain에 USDT를 입금하세요.\n\n입금 후 자동으로 스테이킹 대상자가 됩니다.',
  stakingDelegateDescription: '검증자와 함께할 DOMI 양을 선택하세요.',
  newStakingDelegateDescription1:
    '스테이킹된 코인은 180일간 잠금되며, 매일 잠긴 코인 x 수입의 0.45%를 출금할 수 있습니다(최소 출금 금액은 10입니다).',
  newStakingDelegateDescription2:
    '180일 후에 잠금이 해제되고 총 수익률은 100%가 됩니다. 1,000개의 도미 코인을 잠금하면 180일 후에 2,000개의 도미 코인을 받게 됩니다.',
  newStakingMinDomiAmount: '최소 금액: {0} DOMI',
  stakingActivatingDescription:
    '스터ㅏㅋ운트 활성화 시 다음 몇 일 내에 DOMI가 보상을 받기 시작합니다.',
  stakingActiveDescription:
    '현재 검증자와 함께 DOMI를 지분하고 있습니다. 이 자금에 접근하려면 언스태일 해야 합니다.',
  stakingPlan: '계략',
  stakingAnnualFee: '연간 수수료',
  stakingProduct: '제도물',
  stakingAnnualRoi: '연간 ROI(수익률)',
  stakingLimit: '스테이킹 한도',
  stakingUrl: '스테이킹 URL',
  unlimited: '무한',
  validator: '검증자',
  activating: '활성화',
  active: '활성',
  deactivating: '비활성화',
  inactive: '비활성',
  showDepositAddress: '입금 주소 표시',
  confirmUnstakeTitle: '스테이킹 해제 확인',
  confirmUnstakeDescription:
    '스테이킹을 취소하시겠습니까? 보상을 더 이상 받을 수 없지만 자금을 인출할 수 있습니다.',
  installPwaTitle: 'DWallet 설치',
  installPwaDescription:
    '기기에 앱을 설치하면 언제든지 쉽게 액세스할 수 있습니다.',
  installPwaStepOne: '1. "공유" 버튼을 탭합니다.',
  installPwaStepTwo: '2. "홈 화면에 추가"를 선택합니다.',
  installPwaStepThree:
    '3. 홈 화면으로 이동하여 DWallet을 찾은 다음 DWallet을 클릭합니다.',
  redPacketTitle: '새해 복 많이 받으세요!',
  redPacketAvailable: '무료 레드패킷 선물을 받으려면 여기를 누르세요',
  redPacketUnavailable: '%s에 다시 돌아와서 다른 선물을 받으세요',
  redPacketSnackbar: '레드패킷 선물로부터 %s DOMI를 획득하였습니다!',
  airdropIsAlreadyDoneToday:
    '오늘의 에어드랍이 배포되었습니다. 내일 다시 와서 수령하세요.',
  errorOccurredTryAgainLater: '오류가 발생했습니다. 나중에 다시 시도하세요.',
  settings: '설정',
  free: '무료',
  welcomeAirdropTitle: 'DWallet에 오신 것을 환영합니다!',
  welcomeAirdropAvailable:
    '여기를 누르면 무료 도미 1개를 선물로 받을 수 있습니다.',
  welcomeAirdropUnavailable: '다른 선물을 받으려면 %s 로 돌아와 주세요.',
  welcomeAirdropSnackbar: '환영 선물로 %s DOMI를 받았습니다!',
  usdtDepositNotice:
    '이 주소는 %s에서만 USDT를 받을 수 있습니다. 다른 네트워크의 토큰을 보내지 마세요! USDT를 받은 후 이를 사용하여 DOMI를 구매하고 SESA 에어드랍을 받을 수 있습니다.',
  usdtContractAddress: 'USDT 계약 주소:',
  exchange: '거래소',
  loading: '로드 중...',
  expectedFee: '예상 수수료', // Expected fee N BTC
  youWillReceive: '당신은 받게됩니다', // You will receive N BTC
  selectTheFee: '수수료를 선택하세요',
  fastest: '가장 빠른', // Fastest N sat/vB
  normal: '정상', // Normal N sat/vB
  economy: '경제', // Economy N sat/vB
  sendingTransaction: '거래를 보내는 중...',
  transactionConfirmed: '거래가 확인되었습니다',
  failedToSignAndSendAMultisigTransaction:
    '다중 서명 트랜잭션에 서명하고 전송하지 못했습니다.',
  noAccountsFound: '계정을 찾을 수 없습니다',
  requestFailed: '요청 실패',
  noFeeRates: '수수료 없음',
  insufficientFunds: '자금 부족',
  tenMinutes: '~10분',
  thirtyMinutes: '~30분',
  oneHour: '~1시간',
  buyDomiItemTitle: 'DOMI 구매',
  buyDomiItemSubtitle: 'USDT를 입금하여 DOMI를 구매하세요',
  buyDomiButton: 'DOMI 구매',
  buyDomiDialogTitle: 'DOMI 구매',
  buyDomiMinimumUsdtAmount: '최소 USDT 금액: {0} USDT',
  buyDomiReceiveNotice:
    '교환 후 2개의 USDT마다 2,000개의 SESA 토큰과 1개의 DOMI를 즉시 받게 됩니다.',
  buyButton: '구입하다',
  telegramSubscriptionTitle: '우리의 소셜 네트워크를 구독하세요',
  telegramSubscriptionLink: 'Telegram에서 열려면 클릭하세요',
  telegramSubscriptionLink2: '텔레그램 커뮤니티 링크:',
  telegramInstructions1: 'Telegram이 없는 경우:',
  telegramInstructions2: '기기에 Telegram을 설치하세요',
  telegramInstructions3:
    '또는 Telegram이 있는 다른 기기로 QR 코드를 스캔하세요',
  telegramInstructions4: '링크를 클릭하거나 브라우저에서 여세요',
  telegramInstructions5: '"시작" 버튼을 눌러 Telegram 봇과 채팅을 시작하세요',
  telegramInstructions6: '봇의 지시에 따라 Telegram 커뮤니티에 가입하세요',
  telegramInstructions7: 'DWallet으로 돌아가서 "계속" 버튼을 누르세요',
  subscribeTwitterInstructions: '트위터에서 우리 커뮤니티를 팔로우하세요:',
  twitterSubscriptionLink:
    '트위터에서 열려면 여기를 클릭하고 "팔로우" 버튼을 클릭하세요.',
  referral: {
    title: '추천',
    description: '친구를 추천하여 더 많은 보상을 받으세요!',
    totalReferral: '총 추천 수',
    referralReward: '귀하의 {coin} 추천 보상',
    pendingReward: '대기 중인 {coin} 보상',
    claim: '추천 보상 청구',
    copy: '복사',
    referralLinkLabel: '추천 링크',
    referralLinkLoading: '추천 링크를 로딩 중입니다..',
    guide1: '1. 추천 링크를 친구에게 보냅니다.',
    guide2: '2. 스테이킹을 하면 추가 보상을 받습니다.',
    earningByLevels: '추천 보상 10% 획득',
    teamRewardsByLevels: '팀 보너스',
    updateHeader: '정보 업데이트',
    update: '업데이트',
  },
  referralTable: {
    date: '날짜',
    event: '이벤트',
    walletId: '지갑 ID',
    stakeAmount: '스테이킹 금액',
    registered: '등록됨',
    bonusDomi: '보너스 {0} DOMI',
    domi: '{0} DOMI',
  },
  fufutureItemTitle: 'FuFuture DEX',
  fufutureItemSubtitle: 'FuFuture에서 탈중앙화 옵션을 거래하세요',
  skip: '건너뛰기',
  skipBackupTitle: '지금은 백업을 건너뛸까요?',
  skipBackupDescription:
    '시드 문구는 나중에 계정 메뉴의 "%s"에서 언제든지 확인하고 백업할 수 있습니다. 백업하기 전에 기기를 분실하거나 데이터가 삭제되면 지갑을 복구할 수 없습니다.',
  tokenStaking: {
    sectionTitle: '토큰 스테이킹',
    stakeTitle: '스테이킹',
    apr: '연이율',
    dayLock: '일 잠금',
    minimum: '최소',
    projected: '예상 보상',
    lockedUntil: '잠금 해제일',
    unlocked: '잠금 해제됨',
    claimable: '청구 가능',
    claimed: '청구 완료',
    staked: '스테이킹됨',
    unstaked: '스테이킹 해제됨',
    addMore: '추가',
    back: '뒤로',
    confirmStake: '스테이킹 확인',
    sending: '전송 중…',
    paused: '일시 중지',
    free: '가용 보상',
    daysRunway: '일분 보상 잔여',
    poolHealth: '풀',
    noPools: '보유 토큰에 대한 스테이킹 풀이 아직 없습니다.',
    noBalance:
      '스테이킹할 %s 이(가) 없습니다. 먼저 마켓플레이스에서 구매하세요.',
    insufficientBalance: '잔액 부족',
    topUpRelocks:
      '추가 스테이킹 시 기존 %s 이(가) 전체 잠금 기간 동안 다시 잠깁니다.',
    unstakeHint: '비워 두면 전액 인출됩니다.',
    remainderBelowMinimum: '남은 스테이킹은 0이거나 최소',
    rewardsPaidWithUnstake: '누적 보상이 이번 인출과 함께 지급됩니다.',
    rewardsStayClaimable:
      '보상 금고가 현재 누적 보상을 지급할 수 없습니다. 보상은 계속 청구 가능합니다.',
    rewardsPendingFunding:
      '원금이 인출되었습니다. 풀이 충전되면 보상을 청구할 수 있습니다.',
    errPaused: '이 토큰의 스테이킹이 일시 중지되었습니다',
    errBelowMinimum: '최소 스테이킹 미만',
    errCapExceeded: '풀 용량 초과',
    errRewardsUnderfunded: '풀이 아직 이 수량에 대한 보상을 예약할 수 없습니다',
    errNoPosition: '스테이킹 포지션 없음',
    errLocked: '포지션이 아직 잠겨 있습니다',
    errNothingToClaim: '청구할 보상 없음',
    errInsufficientRewardVault: '보상 금고가 이 지급을 처리할 수 없습니다',
    errExceedsPrincipal: '수량이 스테이킹 잔액을 초과합니다',
    errProgram: '스테이킹 프로그램 오류',
  },
  domiHealth: {
    sectionTitle: 'DomiHealth',
    notPairedTitle: '엣지 노드와 페어링되지 않음',
    notPairedDescription: 'DomiHealth 엣지 노드에 표시된 페어링 QR 코드를 스캔하여 이 지갑을 연결하세요.',
    pairButton: '페어링 코드 스캔',
    pairDialogTitle: '엣지 노드와 페어링',
    scanQrButton: 'QR 코드 스캔',
    pastePairingCodeLabel: '또는 페어링 JSON 붙여넣기',
    pairingInvalid: '유효하지 않은 페어링 코드입니다.',
    forgetEdgeNodeButton: '이 엣지 노드 잊기',
    forgetEdgeNodeConfirm: '이 엣지 노드를 잊으시겠습니까? 다시 연결하려면 페어링 코드를 다시 스캔해야 합니다.',
    pairedWith: '{0}와(과) 페어링됨',
    unlockTitle: '건강 데이터 잠금 해제',
    autoUnlocking: '지갑으로 잠금 해제 중…',
    passphraseFallbackHint: '이 계정은 자동 잠금 해제 기능이 도입되기 전에 생성되었습니다 — 처음 설정한 비밀번호를 입력하세요.',
    passphraseLabel: '로컬 비밀번호',
    passphraseHint: '이 엣지 노드의 데이터를 위한 별도의 비밀번호입니다 — 지갑 비밀번호가 아닙니다.',
    unlockButton: '잠금 해제',
    incorrectPassphrase: '비밀번호가 올바르지 않습니다.',
    lockButton: '잠금',
    recordsTitle: '건강 기록',
    noRecords: '아직 기록이 없습니다.',
    addMeasurementButton: '측정값 추가',
    addMeasurementTitle: '측정값 추가',
    metricTypeLabel: '지표 (예: heart_rate, weight)',
    valueLabel: '값',
    unitLabel: '단위 (선택 사항)',
    saveButton: '저장',
    documentTypeLabel: '무엇을 업로드하시나요?',
    documentTypeLab: '검사 결과지',
    documentTypeGrocery: '장보기 영수증',
    documentTypeRestaurant: '식당 영수증',
    uploadPhotoButton: '사진 촬영 (예: 검사 결과)',
    uploadingPhoto: '업로드 중…',
    uploadFromStorageButton: '저장소에서 파일 선택 (사진 또는 PDF)',
    uploadingFile: '업로드 중…',
    documentUploaded: '업로드되었습니다 — 백그라운드에서 검사 결과를 추출하고 있습니다. 잠시 후 다시 확인해 주세요.',
    groceryReceiptUploaded: '업로드되었습니다 — 백그라운드에서 장보기 품목을 추출하고 있습니다. 잠시 후 다시 확인해 주세요.',
    restaurantReceiptUploaded: '업로드되었습니다 — 백그라운드에서 주문 항목을 추출하고 있습니다. 잠시 후 다시 확인해 주세요.',
    documentAlreadyUploaded: '이 파일은 이미 업로드되어 있습니다 — 새로 추가된 내용이 없습니다.',
    cameraError: '사진을 촬영할 수 없습니다.',
    filePickerError: '해당 파일을 선택하거나 업로드할 수 없습니다.',
    genericError: '엣지 노드와 통신 중 오류가 발생했습니다: {0}',
    insecureConnectionNotice: '이 연결은 아직 엣지 노드의 인증서를 검증하지 않습니다 — 신뢰할 수 있는 네트워크에서만 사용하세요.',
    claimRewardsButton: 'DHT 보상 청구',
    claimingRewards: '청구 내역을 생성하고 제출하는 중…',
    noClaimsAvailable: '현재 청구할 항목이 없습니다.',
    claimsSubmitted: '{0}건의 보상 청구가 제출되었습니다.',
    claimsSkipped: '{0}건의 기록이 건너뛰어졌습니다: {1}',
    claimFailed: '청구 1건이 실패했습니다: {0}',
    backupButton: '내 데이터 백업',
    backingUp: '백업 중…',
    backupComplete: '백업이 생성되었고 온체인 포인터가 업데이트되었습니다.',
    restoreButton: '백업에서 복원',
    restoring: '복원 중…',
    restoreComplete: '백업에서 {0}건의 기록이 복원되었습니다.',
    restoreNoBackupFound: '이 지갑의 백업을 찾을 수 없습니다.',
    deregisterSectionTitle: '엣지 노드를 분실하셨나요?',
    deregisterSectionDescription:
      '엣지 노드를 분실, 도난당하거나 교체한 경우, 새 기기를 등록할 수 있도록 해당 기기 슬롯을 해제하세요. 해당 기기의 공개 키가 필요합니다 — 이는 기기가 처음 시작될 때 자체 터미널/콘솔에 출력됩니다 ("Device identity: ..."). 이 작업은 분실한 기기가 아니라 현재 페어링된 엣지 노드로 수행할 수 있습니다.',
    devicePubkeyLabel: '분실한 기기의 공개 키',
    deregisterButton: '분실 기기 등록 해제',
    deregistering: '등록 해제 중…',
    deregisterComplete: '기기 등록이 해제되었습니다 — 슬롯이 해제되었습니다.',
    anchoredChip: '고정됨',
    pendingChip: '대기 중',
    wellnessAnalysisTitle: '건강 요약',
    chatSectionTitle: '건강 채팅',
    chatSectionDescription: '말하는 대신 입력하여 건강 도우미에게 질문하세요 — 음성 도우미와 동일하게 엣지 노드에서 실행됩니다.',
    chatInputLabel: '건강에 대해 질문해 보세요',
    chatSendButton: '전송',
    chatYouLabel: '나',
    chatAssistantLabel: '도우미',
    voiceSectionTitle: '음성 도우미',
    voiceSectionDescription: '음성 인식과 음성 합성 모두 휴대폰이나 클라우드가 아닌 엣지 노드에서 실행됩니다 — 음성이 로컬 네트워크를 벗어나지 않습니다.',
    startRecordingButton: '녹음 시작',
    stopRecordingButton: '녹음 중지',
    askAssistantButton: '건강 도우미에게 질문',
    saveAsNoteButton: '음성 메모로 저장',
    processingVoice: '처리 중…',
    voiceTranscriptLabel: '내가 말한 내용',
    voiceResponseLabel: '도우미',
    voiceNoteTranscribed: '변환되었습니다 — 아래에서 확인 후 저장을 누르세요.',
    voiceNativeOnly: '지금은 음성 녹음을 사용할 수 없습니다.',
    dashboardSectionTitle: '건강 대시보드',
    dashboardNoFlaggedItems: '현재 정상 범위를 벗어난 항목이 없습니다.',
    dashboardFlaggedItemsCount: '{0}개 항목이 정상 범위를 벗어났습니다',
    dashboardRefreshButton: '새로고침',
    dashboardAskAboutButton: '이 항목에 대해 질문하기',
    askAboutItemQuestion: '제 {0} 수치가 {1} {2}로 정상 범위를 벗어났습니다. 이것이 무엇을 의미하며, 어떤 생활 습관 변화가 도움이 될 수 있는지, 아니면 병원에 가야 하는지 알려주세요.',
    dashboardAsking: '질문하는 중…',
    dashboardTypicalRangeLabel: '정상 범위',
    patientInfoLabel: '환자',
    reportDateLabel: '검사 날짜',
    purchaseDateLabel: '구매 날짜',
    processingDocument: '백그라운드에서 검사 결과를 추출하고 있습니다 — 잠시 후 다시 확인해 주세요',
    labValuesLabel: '검사 수치',
    labValuesCount: '{0}개의 검사 수치가 기록되었습니다',
    groceryItemsCount: '{0}개의 장보기 품목이 기록되었습니다',
    restaurantItemsCount: '{0}개의 주문 항목이 기록되었습니다',
    viewerUploadedAtLabel: '업로드됨',
    viewerPreviewUnavailable: '이 파일 형식({0})은 미리보기를 지원하지 않습니다. 다운로드를 사용하여 기기에 저장하세요.',
    viewerCloseButton: '닫기',
    viewerDownloadButton: '다운로드',
    viewerDownloading: '다운로드 중…',
    viewerDownloadComplete: '"{0}"이(가) 다운로드 폴더에 저장되었습니다.',
    viewerDownloadFailed: '이 파일을 다운로드할 수 없습니다.',
  },
};

export default korean;
